<template>
  <div>
    <order-list :filters="filters"></order-list>
  </div>
</template>
<script>
  import OrderList from 'src/views/admin/e-commerce/orders/OrderList';
  export default {
    name: 'voucher-orders',
    components: {
      OrderList
    },
    computed: {
      filters() {
        return [
          {
            key: 'with',
            value: 'client,user,invoice,product'
          },
          {
            field: 'voucher_id',
            operator: 'IS',
            value: this.$route.params.id
          },
        ]
      }
    }
  }
</script>
<style>
</style>
